// extracted by mini-css-extract-plugin
module.exports = {"treatment-protocol-name-column":"treatment-protocol-name-column___1bywz","dropdown-icon":"dropdown-icon___2jEe_","create-tp-btn":"create-tp-btn___XDxFJ"};